import api from "../../api/api";

export const createAllInstructionmasterModulewise = async (data) =>
  await api.post(`saveModuleWiseInstructions`, data);

export const getAllInstructionsModulewise = async (module) =>
  await api.get(`getModuleWiseInstructions/${module}`);

export const updateInstructionsMaster = async (data) =>
  await api.put(`updateModuleWiseInstructions`, data);
